module.exports = __webpack_public_path__ + "img/ad.9cbf9b9b.jpg";